import Router from './router'
import GlobalStyle from './presentation/styles/global-styles'
import { BrowserRouter } from 'react-router-dom'
import { useEffect, type ReactElement } from 'react'
import { ModalProvider } from './presentation/contexts/modal-context/modal-context'

export default function App (): ReactElement {
  useEffect(() => {
    const newYear = new Date('2026-01-01 00:00:00')
    const interval = setInterval(() => {
      const now = new Date()
      if (now.getTime() < newYear.getTime()) return
      window.location.href = 'https://cartaodetodos.com.br'
    }, 1000)
    return () => { clearInterval(interval) }
  }, [])
  return <BrowserRouter>
    <ModalProvider>
      <Router />
      <GlobalStyle />
    </ModalProvider>
  </BrowserRouter>
}
